export const DEPARTMENT_ID = {
  /** Khoa Công nghệ Thông tin */
  FIT: 4,
  /** Trung tâm Thông tin - Thư viện */
  LIC: 33,
  /** Trung tâm Phục vụ và Nội trú */
  SRL: 44,
  /** Trung tâm CITADT */
  CITADT: 53,
  /** Văn phòng */
  RO: 26,
  /** Phòng Khoa học công nghệ và Hợp tác quốc tế */
  OSTIA: 24,
  /** Phòng Chính trị - Công tác sinh viên */
  OSA: 29,
  /** Phòng Khảo thí và Đảm bảo chất lượng */
  DTQA: 30,
  /** Khoa Giáo dục Tiểu học và Mầm non */
  ECE: 10,
  /** Phòng Quản lý đào tạo */
  TMO: 23,
  /** Khoa Du lịch */
  FOT: 6,
  /** Khoa Toán và Khoa học Tự nhiên */
  FOMANS: 3,
  /** Khoa Công nghệ và Kỹ thuật */
  FST: 14,
  /** Khoa Kinh tế và Quản trị kinh doanh */
  FBM: 17,
  /** Trung tâm SSC */
  SSC: 54,
  /** Khoa Kế toán - Tài chính */
  FAF: 16,
  /** Trung tâm Ngoại ngữ, Tin học và Đào tạo, Bồi dưỡng */
  FLIC: 20,
  /** Khoa Chính trị, Tâm lý và Giáo dục thể chất */
  FPPPE: 13,
  /** Khoa Ngữ văn và Khoa học xã hội */
  FLSS: 7,
  /** Phòng Kế hoạch - Tài chính */
  FPO: 27,
  /** Phòng Tổ chức, Cán bộ và Pháp chế */
  OPLA: 21,
  /** Khoa Ngoại ngữ */
  FFL: 8,
  /** Khoa Tâm lý - Giáo dục học */
  FOPE: 12,
  /** Khoa Xây dựng */
  FOC: 15,
  /** Trung tâm Giáo dục Quốc phòng và An ninh */
  NDSEC: 36,
  /** Phòng Quản trị Cơ sở vật chất và Đầu tư */
  MID: 45,
};